let labelsBuilder = (function () {

    const t = {};

    /**
     * This function convert dataLabels to 'pretty' graph readable labels
     *
     * @param toTime
     * @param interval
     */
    t.getReadableIntervalLabelArrays = function (toTime, interval) {
        let timestamps = {};

        switch (interval) {
            case 'quarterly':
                timestamps = t.createQuarterIntervalLabels(toTime, 'HH:mm');
                break;
            case 'hourly':
                timestamps = t.createHourIntervalLabels(toTime, 'HH:mm');
                break;
            case 'daily':
                timestamps = t.createDailyIntervalLabels(toTime, 'YYYY-MM-DD');
                break;
            case 'weekly':
                timestamps = t.createWeeklyIntervalLabels(toTime, 'YYYY-WW');
                break;
            case 'monthly':
                timestamps = t.createMonthlyIntervalLabels(toTime, 'YYYY-MM');
                break
        }
        return timestamps;

    };
    t.getIntervalStartAndEndTime = function (toTime, interval) {

        let timestamps = {};

        switch (interval) {
            case 'quarterly':
                timestamps = t.getQuarterIntervalStartAndEndTime(toTime);
                break;
            case 'hourly':
                timestamps = t.getHourIntervalStartAndEndTime(toTime);
                break;
            case 'daily':
                timestamps = t.getDailyIntervalStartAndEndTime(toTime);
                break;
            case 'weekly':
                timestamps = t.getWeeklyIntervalStartAndEndTime(toTime);
                break;
            case 'monthly':
                timestamps = t.getMonthlyIntervalStartAndEndTime(toTime);
                break
        }
        return timestamps;
    };

    t.getIntervalDataLabelArrays = function (toTime, interval) {

        let timestamps = {};

        switch (interval) {
            case 'quarterly':
                timestamps = t.createQuarterIntervalLabels(toTime);
                break;
            case 'hourly':
                timestamps = t.createHourIntervalLabels(toTime);
                break;
            case 'daily':
                timestamps = t.createDailyIntervalLabels(toTime);
                break;
            case 'weekly':
                timestamps = t.createWeeklyIntervalLabels(toTime);
                break;
            case 'monthly':
                timestamps = t.createMonthlyIntervalLabels(toTime);
                break
        }
        return timestamps;
    };

    t.getQuarterIntervalStartAndEndTime = function (toTime = '', format = 'YYYY-MM-DD HH:mm:ss') {

        let start = '';

        if (toTime === '') {
            start = moment();
        } else {
            start = moment(toTime);
        }

        let offset = start.minute() % 15;

        const endTime = moment(start).subtract(offset, "minutes").startOf('minute').format(format);
        const startTime = moment(endTime).subtract(6, 'hours').format(format);


        return {start: startTime, end: endTime};
    };

    t.createQuarterIntervalLabels = function (toTime = '', format = 'YYYY-MM-DD HH:mm:ss') {

        let start = '';

        if (toTime === '') {
            start = moment();
        } else {
            start = moment(toTime);
        }

        let offset = start.minute() % 15;

        const endTime = moment(start).subtract(offset, "minutes").startOf('minute');
        let pointer = moment(endTime).subtract(6, 'hours');

        let labels = [];

        while (endTime >= pointer) {
            labels.push(moment(pointer).format(format));
            pointer = moment(pointer).add(15, 'minutes');
        }
        return labels;
    };

    t.getHourIntervalStartAndEndTime = function (toTime = '', format = 'YYYY-MM-DD HH:mm:ss') {

        let start = '';

        if (toTime === '') {
            start = moment();
        } else {
            start = moment(toTime);
        }

        const remainder = start.minute() % 60;

        const endTime = moment(start).subtract(remainder, "minutes").startOf('minute').format(format);
        const startTime = moment(endTime).subtract(24, 'hours').format(format);

        return {start: startTime, end: endTime};
    };

    t.createHourIntervalLabels = function (toTime = '', format = 'YYYY-MM-DD HH:mm:ss') {

        let start = '';

        if (toTime === '') {
            start = moment();
        } else {
            start = moment(toTime);
        }

        const remainder = start.minute() % 60;

        const endTime = moment(start).subtract(remainder, "minutes").startOf('minute');
        let pointer = moment(endTime).subtract(24, 'hours');

        let labels = [];

        while (endTime >= pointer) {
            labels.push(moment(pointer).format(format));
            pointer = moment(pointer).add(60, 'minutes');
        }
        return labels;
    };

    t.getDailyIntervalStartAndEndTime = function (toTime = '', format = 'YYYY-MM-DD HH:mm:ss') {

        let localToTime = moment(toTime);

        let setObject = {
            second: 0,
            minute: 0,
            hour: 0,
            date: localToTime.date(),
            month: localToTime.month(),
            year: localToTime.year(),
        };

        let utcToTime = moment().utc();
        utcToTime.set(setObject);

        let startTime = moment(utcToTime).subtract(30, 'days').local().format(format);
        let endTime = utcToTime.local().format(format);

        return {start: startTime, end: endTime};
    };

    t.createDailyIntervalLabels = function (toTime = '', format = 'YYYY-MM-DD HH:mm:ss') {

        let localToTime = moment(toTime);

        let setObject = {
            second: 0,
            minute: 0,
            hour: 0,
            date: localToTime.date(),
            month: localToTime.month(),
            year: localToTime.year(),
        };

        let utcToTime = moment().utc();
        utcToTime.set(setObject);

        let pointer = moment(utcToTime).subtract(30, 'days');

        let labels = [];

        while (utcToTime >= pointer) {
            let dateLabel = moment(pointer).local();
            labels.push(dateLabel.format(format));
            pointer.add(1, 'day');
        }

        return labels;
    };

    t.getWeeklyIntervalStartAndEndTime = function (toTime = '', format = 'YYYY-MM-DD HH:mm:ss') {

        let localToTime = moment(toTime).startOf('isoWeek');

        let setObject = {
            second: 0,
            minute: 0,
            hour: 0,
            date: localToTime.date(),
            month: localToTime.month(),
            year: localToTime.year(),
        };
        let utcToTime = moment().utc();
        utcToTime.set(setObject);

        let sixMonthsPast = moment(utcToTime).subtract(6, 'months').startOf('isoWeek');

        let endTime = utcToTime.local().format(format);
        let startTime = sixMonthsPast.local().format(format);

        return {start: startTime, end: endTime};
    };

    t.createWeeklyIntervalLabels = function (toTime = '', format = 'YYYY-MM-DD HH:mm:ss') {


        let localToTime = moment(toTime).startOf('isoWeek');

        let setObject = {
            second: 0,
            minute: 0,
            hour: 0,
            date: localToTime.date(),
            month: localToTime.month(),
            year: localToTime.year(),
        };
        let utcToTime = moment().utc();
        utcToTime.set(setObject);

        let pointer = moment(utcToTime).subtract(6, 'months').startOf('isoWeek');

        let labels = [];

        while (utcToTime >= pointer) {
            let dateLabel = moment(pointer).local();
            labels.push(dateLabel.format(format));
            pointer = moment(pointer).add(1, 'weeks');
        }
        return labels;
    };

    t.getMonthlyIntervalStartAndEndTime = function (toTime = '', format = 'YYYY-MM-DD HH:mm:ss') {


        let localToTime = moment(toTime).startOf('month');

        let setObject = {
            second: 0,
            minute: 0,
            hour: 0,
            date: 1,
            month: localToTime.month(),
            year: localToTime.year(),
        };
        let utcToTime = moment().utc();
        utcToTime.set(setObject);

        let twoYearsPast = moment(utcToTime).subtract(2, 'years');

        let endTime = utcToTime.local().format(format);
        let startTime = twoYearsPast.local().format(format);

        return {start: startTime, end: endTime};
    };

    t.createMonthlyIntervalLabels = function (toTime = '', format = 'YYYY-MM-DD HH:mm:ss') {

        let localToTime = moment(toTime).startOf('month');

        let setObject = {
            second: 0,
            minute: 0,
            hour: 0,
            date: 1,
            month: localToTime.month(),
            year: localToTime.year(),
        };
        let utcToTime = moment().utc();
        utcToTime.set(setObject);

        let pointer = moment(utcToTime).subtract(2, 'years');
        let labels = [];

        while (utcToTime >= pointer) {
            let dateLabel = moment(pointer).local();

            labels.push(dateLabel.format(format));
            pointer = moment(pointer).add(1, 'month');
        }
        return labels;
    };

    return t;

})();
